import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {EsperandoElPapel, useEvidenciaPintada} from '@/components/bateria/cola/evidencia-de-la-tarjeta'
import {paqueteDeRef, type TarjetaCola} from '@/lib/bateria-cola'
import {usePaginaImagen} from '@/hooks/bateria/use-pagina-imagen'

/**
 * La hoja escaneada donde está la pregunta, a tamaño de leer letra a mano: un campo manuscrito
 * no tiene recorte calibrado. Las esperas y las fallas se dicen.
 */
export function PaginaDelPapel({
  tarjeta,
  businessId,
  evaluacionId,
}: {
  tarjeta: TarjetaCola
  businessId: string
  evaluacionId: string
}) {
  const {t} = useTranslation()
  const [fallo, setFallo] = useState(false)
  const [cargada, setCargada] = useState(false)
  const numero = tarjeta.pagina_numero
  const {data, isLoading} = usePaginaImagen(businessId, evaluacionId, paqueteDeRef(tarjeta.ref), numero)
  useEvidenciaPintada(data?.url ?? '', cargada || fallo)

  if (isLoading) {
    return (
      <EsperandoElPapel testId="cola-campo-pagina-cargando">
        {t('admin.bateria.cola.papel.buscandoHoja')}
      </EsperandoElPapel>
    )
  }
  if (!data || fallo) {
    return (
      <p className={AVISO} data-testid="cola-campo-sin-hoja">
        {t('admin.bateria.cola.papel.sinHoja')}
      </p>
    )
  }
  return (
    <figure className="space-y-1.5">
      <figcaption className="font-mono text-[11px] tracking-wider text-muted-foreground uppercase">
        {t('admin.bateria.cola.papel.leaDelPapel', {numero})}
      </figcaption>
      <a
        href={data.url}
        target="_blank"
        rel="noreferrer"
        className="block cursor-zoom-in"
        data-testid="cola-campo-pagina-lupa">
        <img
          src={data.url}
          alt={t('admin.bateria.cola.papel.hojaAlt', {numero})}
          onLoad={() => setCargada(true)}
          onError={() => setFallo(true)}
          className="block max-h-[26rem] w-full rounded-md border border-border object-contain object-top"
          data-testid="cola-campo-pagina"
        />
      </a>
    </figure>
  )
}

const AVISO = 'rounded-md border border-dashed border-border px-3 py-4 text-center text-xs text-muted-foreground'
